import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from "./context/AuthContext";
import { CityProvider } from "./context/CityContext";

// Remove server-rendered title/meta/link SEO tags so React's own (from Seo.jsx) don't end up
// duplicated alongside them. JSON-LD script[data-ssr] is left in place - Seo.jsx doesn't render it.
document.querySelectorAll('title[data-ssr], meta[data-ssr], link[data-ssr]').forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <CityProvider>
                <App />
            </CityProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
